
  import SsrCarousel from 'vue-ssr-carousel'
  import { mapGetters, mapActions } from 'vuex'
  import productData from '@/data/products.json'
  import reviewData from '@/data/reviews.json'

  export default {
    name: 'CourseCardsDiploma',
    components: { SsrCarousel },
    props: {
      region: {
        default: null,
        type: String,
      },
    },
    data() {
      return {
                reviews: reviewData,
                courseDescriptionsOverride: {
                  "10204": "Offering more comprehensive training, our 250-hour Level 5 TEFL Diploma is a great option for those who would benefit from giving their CV a boost. Don’t have a degree? Not a native English speaker? No previous teaching experience? We’d recommend this Level 5 Diploma!",
                  "10205": "Combine our popular 250-hour Level 5 TEFL Diploma with a 20-hour classroom course. A great option for anyone looking for comprehensive TEFL training that will boost both CV and confidence.",
                  "10207": "Complete your classroom training during the week, with our 280-hour Level 5 TEFL Diploma. Combining our 250-hour Level 5 TEFL Diploma, which you’ll complete online, with a 30-hour weekday classroom course held either in person or virtually.",
                  "10206": "Combine our popular 250-hour Level 5 TEFL Diploma with a 20-hour virtual classroom course. A great option for anyone looking for comprehensive TEFL training that will boost both CV and confidence.",
                },
                // Map to override course durations not available in productData.json (ISO 8601 format)
                courseDurationOverride: {
                  "10204": "P7M",
                  "10205": "P7M",
                  "10207": "P7M",
                  "10206": "P7M",
                },
      }
    },
    head() {
      if(this.page === 'level-5') {
        return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
    computed: {
      ...mapGetters({
          activeModal: 'pages/getActiveModal',
          page: 'pages/getPage',
          userRegion: 'user/region'
      }),
      liveRegion() {
        // the region that actually flips after mount — this is what destabilises the carousel
        return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
      },
      pageRegion() {
        return this.region || (this.$route.path.startsWith('/en-us') ? 'us' : 'uk')
      },
      productIds() {
        return this.pageRegion === 'uk' ? ['1', '8'] : ['10166', '10171']
      },
      products() {
        const products = this.productIds.map((id) => {return productData.find((product) => {return product.id.toString() === id})})
        return products
      },
      priceData() {
        const priceDataArray = []
        this.products.forEach((product) => {
          const priceD = this.$options.filters.priceData(product)
          priceDataArray.push(priceD)
        })
        return priceDataArray
      },
      prices(){
          const prices = []
          this.priceData.forEach((priceData) => {
            const price = this.$nuxt.$options.filters.priceFromLabelNumber(priceData.pricesDiscounted)
            prices.push(price)
          })
          return prices
        },
      currency(){
          const currency = this.$nuxt.$options.filters.currencyCodeFromLabel()
          return currency
        },
      structuredData() {
        const averageRating = this.$nuxt.$options.filters.roundScore(Number(this.reviews.stats.company.average_rating))
        const ratingCount = this.reviews.stats.company.review_count
        const activeRegion = this.region === 'us' ? 'en_us' : this.region
        console.log('activeRegion: ', activeRegion)
        const baseUrl = "https://www.tefl.org"

        // Common provider details for all courses
        const commonProvider = {
          "@id": "https://www.tefl.org/#educationalorganization",
          "@type": "Organization",
          "name": "The TEFL Org",
          "logo": "https://www.tefl.org/_nuxt/images/tefl-org-web_strapline-ee5f8b.svg",
          "url": "https://www.tefl.org/",
          "sameAs": [ "https://www.facebook.com/teflorg", "https://x.com/TEFLOrg", "https://www.instagram.com/teflorg/" , "https://www.linkedin.com/company/teflorg/" ],
        };

        // Common educational credential awarded details for all courses
        const commonEducationalCredential = {
          "@type": "EducationalOccupationalCredential",
          "name": "Tefl Org Certificate",
          "credentialCategory": "Certificate",
          "url": "https://www.tefl.org/about-us/accreditation/",
          "educationalLevel": "beginner"
        };

        // Define the common prerequisite string directly
        const commonPrerequisite = "No prior experience or qualifications are required to take this course.The course is for both native and non-native speakers. However, you must speak English fluently.";


        // Common audience details for all courses
        const commonAudience = {
          "@type": "Audience",
          "audienceType": [
            "People who are serious about teaching English as a foreign language.",
            "Those who are interested in the opportunity to work in most countries in the world.",
            "Professionals who want to re-educate themselves.",
            "Students who are considering a gap year.",
            "Anyone who would like a career teaching online."
          ]
        };

        // Map over the 'products' array to generate structured data for each course
        const itemListElement = this.products.map((product, index) => { // Changed 'course' to 'product' for clarity here
          const coursePrice = this.prices[index] ? this.prices[index].toString() : "0"; // Fallback to "0" if price not found

          // Extract image URL from the 'page' object, prioritizing region-specific then general 'en' or 'en_us'
          const courseImage = product.page?.[activeRegion]?.thumbnail || product.page?.en?.thumbnail || product.page?.en_us?.thumbnail || 'https://placehold.co/400x200/cccccc/333333?text=No+Image';

          // get uri
        const uri = product.page?.[activeRegion]?.uri || product.page?.en?.uri || product.page?.en_us?.uri

          // Derive timeRequired and courseWorkload from 'course.hours' if available
          const courseTimeRequired = product.course?.hours ? `PT${product.course.hours}H` : '';
          const courseWorkload = product.course?.hours ? `PT${product.course.hours}H` : '';

          // Determine courseMode based on specific product ID for 'Online Teaching Practice'
          let courseMode = "online";
          if (product.id.toString() === '10161') { // ID for Online Teaching Practice
              courseMode = "onsite";
          }

          // Use the overridden description if available, otherwise fallback to product.description
          const description = this.courseDescriptionsOverride[product.id.toString()] || product.description;
          // Use the overridden duration if available, otherwise fallback to empty string
          const duration = this.courseDurationOverride[product.id.toString()] || '';


          return {
            "position": (index + 1).toString(),
            "@type": "Course",
            "name": product.name,
            "image": courseImage,
            "url": `${baseUrl}${uri}`,
            description, // Use the determined description
            // Fields derived from productData.json
            "timeRequired": courseTimeRequired,
            "learningResourceType": "Course",
            // Use the hardcoded common prerequisite
            "coursePrerequisites": commonPrerequisite,
            "offers": {
              "@type": "offer",
              "category": "Paid",
              "price": coursePrice,
              "priceCurrency": this.currency,
              "availability": "https://schema.org/InStock",
            },
            "provider": commonProvider,
            "hasCourseInstance": {
              "@type": "CourseInstance",
              courseMode,
              courseWorkload,
              duration, // Use the determined duration
            },
            "inLanguage": "en",
            "interactivityType": "active",
            "educationalCredentialAwarded": commonEducationalCredential,
            "audience": commonAudience,
            "about": "Teaching English as a Foreign Language",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": averageRating,
              ratingCount,
              "bestRating": 5
            },
          };
        });

        return {
          "@context": "https://schema.org/",
          "@type": "ItemList",
          itemListElement
        };
      }
    },
    methods: {
      ...mapActions({
        updateActiveModal: 'pages/updateActiveModal',
      }),
      updateModal(id) {
        this.updateActiveModal(id)
      },
      hideModal() {
        this.updateActiveModal(null)
      },
    },
  }
  